import { routeName } from 'shared/constants.json';
// routes
export const ACCESS_GROUP_LIST = routeName.accessGroupList;
export const ACCOUNT_SETTINGS = routeName.accountSettings;
export const GOALS_EXPLORER = routeName.goalsExplorer;
export const UPDATES_EXPLORER = routeName.updatesExplorer;
export const GOAL_INSIGHTS = routeName.goalInsights;
export const GOAL_DETAILS = routeName.goalDetails;
export const SPACE_DETAILS = routeName.spaceDetails;
export const PROFILE = routeName.profile;
export const HOME = routeName.home;
export const USER_FIELDS_NO_SELECTION = routeName.propertysNoSelection;
export const USER_LIST = routeName.userList;
export const PROFILE_SETTINGS = routeName.profileSettings;
export const NOT_FOUND = routeName.notFound;
